// Perbaikan kode lengkap AdminDashboard
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase";
import { getDatabase, ref, onValue, update } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import { toast } from "react-toastify";

// Fungsi Fetch Deposits
const fetchDeposits = (setDeposits) => {
    const db = getDatabase();
    const depositsRef = ref(db, "deposits");

    onValue(depositsRef, (snapshot) => {
        const depositsData = snapshot.val();
        if (depositsData) {
            const allDeposits = [];
            Object.keys(depositsData).forEach((userId) => {
                const userDeposits = depositsData[userId];
                Object.keys(userDeposits).forEach((depositId) => {
                    const deposit = userDeposits[depositId];
                    allDeposits.push({
                        userId,
                        depositId,
                        amount: deposit.amount,
                        method: deposit.method,
                        timestamp: deposit.timestamp,
                        status: deposit.status || "pending"
                    });
                });
            });
            setDeposits(allDeposits);
        } else {
            setDeposits([]);
        }
    });
};

const AdminDeposit = () => {
    const navigate = useNavigate();
    const [statuses] = useState({});
    const [currentPageDeposits, setCurrentPageDeposits] = useState(0);
    const [searchQueryDeposits, setSearchQueryDeposits] = useState("");
    const [deposits, setDeposits] = useState([]);
    const [setDepositStatuses] = useState({});
    const itemsPerPage = 5;

    // Cek autentikasi admin
    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                if (user.email !== "padild940@gmail.com") {
                    navigate("/");
                }
            } else {
                navigate("/");
            }
        });

        fetchDeposits(setDeposits);

        return () => unsubscribe();
    }, [navigate]);

    // Fungsi untuk mengubah status deposit
    const updateDepositStatus = (userId, depositId, newStatus) => {
        const db = getDatabase();
        const depositRef = ref(db, `deposits/${userId}/${depositId}`);
        update(depositRef, { status: newStatus })
            .then(() => {
                toast.success(`Status deposit diubah menjadi ${newStatus}`);
                setDepositStatuses((prevStatuses) => ({
                    ...prevStatuses,
                    [depositId]: newStatus
                }));
            })
            .catch((error) => {
                console.error("Gagal memperbarui status deposit:", error);
            });
    };

    const convertTimestampToDate = (timestamp) => {
        const date = new Date(timestamp);
        return date.toLocaleString("id-ID", {
            day: "2-digit",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "pending":
                return "bg-yellow-200 text-yellow-800";
            case "tolak":
                return "bg-red-200 text-red-800";
            case "success":
                return "bg-green-200 text-green-800";
            default:
                return "bg-yellow-200 text-yellow-800";
        }
    };

    // Filter data deposit
    const filteredDeposits = deposits.filter((deposit) => {
        const userId = deposit.userId.toLowerCase();
        const depositId = deposit.depositId.toLowerCase();
        const query = searchQueryDeposits.toLowerCase();
        return userId.includes(query) || depositId.includes(query);
    });

    const paginatedDeposits = filteredDeposits.slice(
        currentPageDeposits * itemsPerPage,
        (currentPageDeposits + 1) * itemsPerPage
    );

    // Navigasi halaman untuk deposit
    const nextPageDeposits = () => {
        if (
            (currentPageDeposits + 1) * itemsPerPage <
            filteredDeposits.length
        ) {
            setCurrentPageDeposits(currentPageDeposits + 1);
        }
    };

    const prevPageDeposits = () => {
        if (currentPageDeposits > 0) {
            setCurrentPageDeposits(currentPageDeposits - 1);
        }
    };

    return (
        <>
            <div className="mb-4">
                <input
                    type="text"
                    placeholder="Cari berdasarkan User ID atau Deposit ID"
                    className="w-full p-2 border rounded-md"
                    value={searchQueryDeposits}
                    onChange={(e) => {
                        setSearchQueryDeposits(e.target.value);
                        setCurrentPageDeposits(0);
                    }}
                />
            </div>

            {/* Daftar Deposit */}
            <div className="mb-4 p-4 bg-gray-100 rounded-md">
                <h2 className="text-lg font-semibold mb-4">Daftar Deposit</h2>
                {paginatedDeposits.length > 0 ? (
                    <>
                        <div className="overflow-x-auto">
                            <table className="w-full table-auto border-collapse border border-gray-200">
                                <thead>
                                    <tr className="bg-gray-300">
                                        <th className="border p-2">User ID</th>
                                        <th className="border p-2">
                                            Deposit ID
                                        </th>
                                        <th className="border p-2">Jumlah</th>
                                        <th className="border p-2">Tanggal</th>
                                        <th className="border p-2">Status</th>
                                        <th className="border p-2">Aksi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {paginatedDeposits.map((deposit) => (
                                        <tr
                                            key={deposit.depositId}
                                            className="text-center"
                                        >
                                            <td className="border p-2">
                                                {deposit.userId}
                                            </td>
                                            <td className="border p-2">
                                                {deposit.depositId}
                                            </td>
                                            <td className="border p-2">
                                                Rp {deposit.amount}
                                            </td>
                                            <td className="border p-2">
                                                {convertTimestampToDate(
                                                    deposit.timestamp
                                                )}
                                            </td>
                                            <td className="border p-2">
                                                <span
                                                    className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(
                                                        statuses[
                                                            deposit.depositId
                                                        ] || deposit.status
                                                    )}`}
                                                >
                                                    {statuses[
                                                        deposit.depositId
                                                    ] || deposit.status}
                                                </span>
                                            </td>
                                            <td className="border p-2">
                                                <select
                                                    className="p-2 border rounded-md"
                                                    value={
                                                        statuses[
                                                            deposit.depositId
                                                        ] || deposit.status
                                                    }
                                                    onChange={(e) =>
                                                        updateDepositStatus(
                                                            deposit.userId,
                                                            deposit.depositId,
                                                            e.target.value
                                                        )
                                                    }
                                                >
                                                    <option value="pending">
                                                        Tunda
                                                    </option>
                                                    <option value="tolak">
                                                        Tolak
                                                    </option>
                                                    <option value="success">
                                                        Sukses
                                                    </option>
                                                </select>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        {/* Navigasi halaman */}
                        <div className="flex justify-center items-center mt-4">
                            <button
                                onClick={prevPageDeposits}
                                disabled={currentPageDeposits === 0}
                                className={`px-4 py-2 border ${
                                    currentPageDeposits === 0
                                        ? "bg-gray-300 cursor-not-allowed"
                                        : "bg-blue-500 text-white"
                                }`}
                            >
                                <FaAngleLeft />
                            </button>
                            <span className="px-4">
                                Halaman {currentPageDeposits + 1} dari{" "}
                                {Math.ceil(
                                    paginatedDeposits.length / itemsPerPage
                                )}
                            </span>
                            <button
                                onClick={nextPageDeposits}
                                disabled={
                                    (currentPageDeposits + 1) * itemsPerPage >=
                                    paginatedDeposits.length
                                }
                                className={`px-4 py-2 border ${
                                    (currentPageDeposits + 1) * itemsPerPage >=
                                    paginatedDeposits.length
                                        ? "bg-gray-300 cursor-not-allowed"
                                        : "bg-blue-500 text-white"
                                }`}
                            >
                                <FaAngleRight />
                            </button>
                        </div>
                    </>
                ) : (
                    <p className="text-center">
                        Tidak ada deposit yang sesuai.
                    </p>
                )}
            </div>
        </>
    );
};

export default AdminDeposit;
